import { render, staticRenderFns } from "./ProjectAppointment.vue?vue&type=template&id=c5147480&scoped=true&"
import script from "./ProjectAppointment.vue?vue&type=script&lang=js&"
export * from "./ProjectAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAppointment.vue?vue&type=style&index=0&id=c5147480&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5147480",
  null
  
)

export default component.exports